import React from "react";
import { Box, Image, Text, Flex, Skeleton } from "@chakra-ui/react";
import {
  FaStar,
  FaRegStar,
  FaStarHalfAlt,
  FaShoppingBag,
} from "react-icons/fa";

import { Stars } from "../Stars/Stars";
import { SalePrice } from "./SalePrice";

import { ProductCardProps } from "../../interface/interface";
import { calculateStars } from "../../utils/utils";

const ProductCard: React.FC<ProductCardProps> = ({
  image,
  name,
  price,
  rating,
  actualPrice,
  isSale,
}) => {
  const { fullStars, hasHalfStar, greyStars } = calculateStars(rating);
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <Box p={4} w={{ base: "100%", sm: "50%", md: "33.33%", lg: "25%" }}>
      <Skeleton
        isLoaded={isImageLoaded}
        display="flex"
        flexDirection="column"
        gap="8px"
        width="100%"
        height="100%"
      >
        <Image
          src={image}
          alt={name}
          loading="lazy"
          onLoad={handleImageLoad}
          borderRadius="10px"
        />
        <Text>{name}</Text>
        <Flex>
          <Stars count={fullStars} Icon={FaStar} color="gold" />
          {hasHalfStar && <Stars count={1} Icon={FaStarHalfAlt} color="gold" />}
          <Stars count={greyStars} Icon={FaRegStar} color="grey" />
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          {isSale ? (
            <SalePrice actualPrice={actualPrice} price={price} />
          ) : (
            <Text>AED {price}</Text>
          )}

          <FaShoppingBag />
        </Flex>
      </Skeleton>
    </Box>
  );
};

export default ProductCard;
